import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Dashboard from './layouts/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import UmrahPackages from './pages/UmrahPackages';
import TravelOptions from './pages/TravelOptions';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/" render={() => <Redirect to="/bookings" />} />
          <Route
            path="/bookings"
            render={(props) => (
              <ProtectedRoute>
                <Dashboard>
                  <AdminDashboard {...props} />
                </Dashboard>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/umrah-packages"
            render={(props) => (
              <ProtectedRoute>
                <Dashboard>
                  <UmrahPackages {...props} />
                </Dashboard>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/travel-options"
            render={(props) => (
              <ProtectedRoute>
                <Dashboard>
                  <TravelOptions {...props} />
                </Dashboard>
              </ProtectedRoute>
            )}
          />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
